/** Server user id for web sessions — scopes localStorage seed + query cache. */

let webUserId: string | null = null;

export function setWebUserId(id: string | null): void {
  webUserId = id;
}

export function getWebUserId(): string | null {
  return webUserId;
}
